angular.module('SpidApp')

.controller('TeamController', function ($scope, BASE_PUBLIC_URL) {
    $scope.images = {
          francis : BASE_PUBLIC_URL + '/images/team/francis.jpg'
        , kevin   : BASE_PUBLIC_URL + '/images/team/kevin.jpg'
        , marcel  : BASE_PUBLIC_URL + '/images/team/marcel.jpg'
        , joey    : BASE_PUBLIC_URL + '/images/team/joey.jpg'
    }
})